import HttpClient from "../httpClient";

class CommonService {
    private service = HttpClient;

    async uploadFile(formData: FormData): Promise<any> {
        const response = await this.service.postBinary<any>("/admin/File/Upload", formData);
        return response;
    }

    async deleteFile(id: number): Promise<any> {
        const response = await this.service.post<any>(`/admin/File/Delete?id=${id}`);
        return response;
    }

    async getLookupDeviceStatuses(): Promise<any> {
        const response = await this.service.get<any>(`/admin/DeviceStatuses/GetDeviceStatusLookup`);
        return response;
    }
}

const commonSvc = new CommonService();
export default commonSvc;
